import EmailSubscribe, { PAGE_TYPE } from '@elem/compCommon/EmailSubscribe';
import SideMenu, { SideMenuProps } from '@elem/compCommon/SideMenu';
import { createPortal } from 'react-dom';
import B from './components/B';
import C from './components/C';
import D from './components/D';
import E from './components/E';
import E_GS from './components/E_GS';
import E_NA from './components/E_NA';
import F from './components/F';
import F_GS from './components/F_GS';
import F_NA from './components/F_NA';
import G from './components/G';
import H from './components/H';
import J from './components/J';
import K from './components/K';
import L from './components/L';
import M from './components/M';
// import N from './components/N';
import ProductInlineBanner from '@/components/PIBanner';
import { useGlobal } from '@/utils/useGlobal';
import G2 from './components/G2';
import H2 from './components/H2';
import JoinUs from './components/JoinUs';
import O from './components/O';
import P from './components/P';
import Q from './components/Q';
import R from './components/R';

export default function IndexDynamic() {
    const { useState, useLang, useEffect, useRouter } = useGlobal();
    const { locale } = useRouter();
    const [isClient, setIsClient] = useState(false);
    const { t } = useLang('vanliferoadtrips');
    const EU_SITES: string[] = ['eu', 'uk', 'de', 'fr', 'it', 'es', 'nl'];
    const IS_NA: boolean = ['us', 'ca'].includes(locale);
    const IS_EU: boolean = ['eu', 'uk', 'de', 'fr', 'it', 'es', 'nl'].includes(locale);
    const IS_RW: boolean = ['au', 'za', 'kr'].includes(locale);

    const obj: SideMenuProps = ['nl'].includes(locale)
        ? {
              items: [
                  { text: t('secC_btn1'), link: '#vanlife-roadtrips-D' },
                  { text: t('secC_btn2'), link: '#vanlife-roadtrips-G' },
                  { text: t('secC_btn4'), link: '#vanlife-roadtrips-L' },
                  { text: t('secC_btn5'), link: '#vanlife-roadtrips-G2' },
              ],
          }
        : EU_SITES.includes(locale)
        ? {
              items: [
                  { text: t('secC_btn1'), link: '#vanlife-roadtrips-D' },
                  { text: t('secC_btn2'), link: '#vanlife-roadtrips-G' },
                  { text: t('secC_btn4'), link: '#vanlife-roadtrips-L' },
                  ...(['eu', 'uk', 'de', 'fr', 'nl'].includes(locale) ? [{ text: t('secC_btn5'), link: '#vanlife-roadtrips-G2' }] : []),
                  { text: t('secC_btn3'), link: '#vanlife-roadtrips-J' },
              ],
          }
        : {
              items: [
                  { text: t('secC_btn1'), link: '#vanlife-roadtrips-D' },
                  { text: t('secC_btn2'), link: '#vanlife-roadtrips-G' },
                  { text: t('secC_btn3'), link: '#vanlife-roadtrips-J' },
                  { text: t('secC_btn4'), link: '#vanlife-roadtrips-L' },
              ],
          };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setIsClient(true);
        }
    }, []);

    // E_NA E_GS E F_NA F_GS F H H2 M N

    return (
        <>
            <B />
            <C tags={obj.items} />
            <D />
            {IS_NA && <E_NA />}
            {(IS_EU || IS_RW) && <E_GS />}
            {!IS_NA && !IS_EU && !IS_RW && <E />}
            {IS_NA && <ProductInlineBanner />}
            {IS_NA && <F_NA />}
            {(IS_EU || IS_RW) && <F_GS />}
            {!IS_NA && !IS_EU && !IS_RW && <F />}
            <G />
            <H />
            {!EU_SITES.includes(locale) && (
                <>
                    <J />
                    <K />
                </>
            )}
            <L />
            <M />

            {['eu', 'uk', 'de', 'fr', 'nl'].includes(locale) && (
                <>
                    <G2 />
                    <H2 />
                </>
            )}
            {EU_SITES.includes(locale) && !['nl'].includes(locale) && (
                <>
                    <J />
                    <K />
                </>
            )}
            {/* shopify暂无该商品，隐藏 */}
            {/* <N  /> */}
            {['au'].includes(locale) && <JoinUs />}
            {!['eu', 'uk', 'it', 'es', 'kr', 'nl'].includes(locale) && <O />}
            <EmailSubscribe locale={locale} className="email-subscribe" pageType={PAGE_TYPE.RoadTrips} entry_position={13} />
            <P />
            {!['eu', 'kr', 'nl'].includes(locale) && <Q />}
            <R />
            {t('secS_title') && (
                <div className="annotation">
                    <p className="title">{t('secS_title')}</p>
                    {t('secS')}
                </div>
            )}
            {isClient && createPortal(<SideMenu items={obj.items} />, document.querySelector('#Widgets-box-in2-right-id') || document.body)}
        </>
    );
}
